import React, { FC } from 'react';
import { format } from 'date-fns';
import { TableCellMiddle, TableCellEnd, TableCellStart } from 'components/Table/TableCellCustom';
import TableRowCustom from 'components/Table/TableRowCustom';
import NumberFormat from 'components/NumberFormat';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { Checkbox, Typography, makeStyles, Theme } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import { TypeJournalTransactions } from 'pages/TransactionJurnalPage';

interface Props {
  isLoading: boolean;
  //invoicePayment: InvoicePaymentModel;
  checked: number[];
  handleIndividualCheck: (id: number) => void;
  journalTransactions: transactionJurnal;
}

const useStyles = makeStyles((theme: Theme) => ({
  linkText: {
    textDecorationLine: 'underline',
    cursor: 'pointer'
  }
}));

const BodyRow: FC<Props> = props => {
  const classes = useStyles();
  const { journalTransactions, isLoading, checked, handleIndividualCheck } = props;
  const { id } = journalTransactions;

  const checkedCheckbox = checked.filter(checkedValue => checkedValue === id).length;
  const isChecked = checkedCheckbox === 0 ? false : true;

  console.log('journalTransactions', journalTransactions);

  const handleLink = (id: Number) => {
    window.open(`/invoice/${id}`);
  };

  return (
    <TableRowCustom>
      <TableCellStart>
        {isLoading ? (
          <Skeleton variant='text' width={'100%'} height={25} />
        ) : (
          <Checkbox
            key={id}
            icon={<CheckBoxOutlineBlankIcon />}
            checkedIcon={<CheckBoxIcon />}
            edge='start'
            color='primary'
            checked={isChecked}
            tabIndex={-1}
            disableRipple
            //disabled={journalTransactions.giroNumber && new Date(journalTransactions.giroDueDate) > new Date()}
            onChange={event => handleIndividualCheck && handleIndividualCheck(id)}
          />
        )}
      </TableCellStart>
      <TableCellMiddle>{isLoading ? <Skeleton variant='text' width={'100%'} height={25} /> : journalTransactions.giroNumber}</TableCellMiddle>
      <TableCellMiddle>{isLoading ? <Skeleton variant='text' width={'100%'} height={25} /> : journalTransactions.name || '-'}</TableCellMiddle>
      <TableCellMiddle>
        {isLoading ? (
          <Skeleton variant='text' width={'100%'} height={25} />
        ) : (
          journalTransactions.giroDueDate && format(new Date(journalTransactions.giroDueDate), 'dd MMM yyyy')
        )}
      </TableCellMiddle>
      <TableCellMiddle>
        {isLoading ? (
          <Skeleton variant='text' width={'100%'} height={25} />
        ) : (
          <NumberFormat
            value={journalTransactions.credit > 0 ? journalTransactions.credit : journalTransactions.debit > 0 ? journalTransactions.debit : 0}
            prefix={'Rp'}
            thousandSeparator={true}
            displayType='text'
          />
        )}
      </TableCellMiddle>
      <TableCellEnd>{isLoading ? <Skeleton variant='text' width={'100%'} height={25} /> : journalTransactions.giroBank}</TableCellEnd>
    </TableRowCustom>
  );
};

export default BodyRow;
